import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../Cadastrar-Vagas-Estagio/CadastrarVagasEstagio2.css";
import Navbar from "../../../components/layout/Navbar/Navbar";
import Sidebar from "../../../components/layout/Sidebar/Sidebar";
import SolicitarHeader from "../../../components/Solicitar-Vagas/SolicitarHeader";
import SolicitarForm from "../../../components/Solicitar-Vagas/SolicitarForm";
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";

const SolicitarVagasEstagio = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const vagaSelecionada = location.state?.vaga || null;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const userData = await apiService.getCurrentUser();
        setUser(userData);

        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error("Erro ao buscar dados:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleVoltar = () => {
    navigate(location.state?.returnPath || "/VagasDisponibilizadas");
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <div className="CadastrarEspecialidades-Page">
      <div className="navbar">
        <Navbar onLogout={apiService.logout} />
      </div>
      <div className="container">
        <div className="sidebar">
          <Sidebar items={sidebarItems} />
        </div>
        <div className="main-content">
          <SolicitarHeader />
          <SolicitarForm user={user} vaga={vagaSelecionada} onVoltar={handleVoltar} />
        </div>
      </div>
    </div>
  );
};

export default SolicitarVagasEstagio;
